'use strict'
import {default as throwError} from "../../../libs/@elements/throw-error";
import asyncAppend from "../../../libs/@elements/async-append";
import fetch from '../../../libs/@elements/fetch';
import {getLoadingContainer, removeLoadingContainer} from "../../../scripts/loading";
import formDataEntries from "form-data-entries";

let $container;


export function initInScope($scope) {

    const $oldContainer = $container;
    $container = $scope.hasClass('js-strex-products__container') ? $scope : $scope.find('.js-strex-products__container');

    $scope.off("click.deactivateProducts").on("click.deactivateProducts", function () {
        $scope.find(".js-strex-products__product.active").removeClass("active");
    })

    if ($container.length) {
        initStrexProducts($container)
    } else {
        $container = $oldContainer;
    }
}

function initStrexProducts($scope) {
    const
        $tracks = $scope.find('.js-strex-draw__track'),
        $trackDetail = $scope.find('.js-strex-products__detail'),
        $trackDetailResult = $scope.find('.js-strex-products__detail-result'),
        $trackDetailClose = $scope.find('.js-strex-products__detail-close'),
        $lightbox = $('.js-modal--strex-add-product');

    $tracks.on('click', (e) => {
        e.preventDefault();
        getTrackDetail($(e.currentTarget));
    });

    // add accessibility
    $tracks.on('keydown', (event) => {
        if (event.code === 'Space' || event.code === 'Enter') {
            $(event.delegateTarget).trigger('click');
        }
    })

    $trackDetailClose.on('click', () => {
        if (pendingRequest) {
            pendingRequest.abort();
            pendingRequest = null;
        }
        $tracks.removeClass('active');
        $trackDetail.stop().slideUp();
    })

    if ($trackDetail.css('display') !== 'none') {
        initTrackDetail();
    }

    let pendingRequest;

    function getTrackDetail($track) {
        const
            url = $track.data('href'),
            $trackContainer = $track.closest('.js-strex-draw__track-container'),
            trackId = $track.data('track-id');

        $tracks.removeClass('active');
        $trackContainer.find('rect.js-strex-draw__track').addClass('active');

        if (!url) {
            throwError('no url on ' + $track);
            return;
        }

        if (pendingRequest) {
            pendingRequest.abort();
            pendingRequest = null;
        }
        const params = new URLSearchParams;

        pendingRequest = fetch(url, {
            method: 'post',
            body: params
        })

        $trackDetail.stop().slideDown();

        $('html, body').animate({
            scrollTop: $trackDetail.offset().top
        }, 800);


        asyncAppend({
            $target: $trackDetailResult,
            $loading: $(getLoadingContainer()).appendTo($trackDetail)
        }, pendingRequest).then(() => {
            initTrackDetail();
        })

        pendingRequest.finally(() => {
            removeLoadingContainer($trackDetail);
            pendingRequest = null;
        })
    }

    function initTrackDetail() {
        const
            $products = $trackDetail.find('.js-strex-products__product'),
            $addProduct = $trackDetail.find('.js-strex-products__trigger-product'),
            $changeTrigger = $trackDetail.find('.js-strex-products__trigger-change'),
            $lightboxTrigger = $trackDetail.find('.js-strex-products__trigger-lightbox'),
            $lightboxContainer = $lightbox.find('.js-strex-products__grid-container');

        //fot accessibility
        $trackDetail.find('a, button, input').get(0).focus();

        let changeRequest;
        $changeTrigger.on('click', (e) => {
            e.preventDefault();

            const
                $target = $(e.currentTarget),
                url = $target.data('href');

            changeRequest = fetch(url, {
                method: 'post'
            });

            asyncAppend({
                $target: $container,
                $loading: $(getLoadingContainer()).appendTo($container)
            }, changeRequest).catch((error) => {
                console.error(error)
            })

            changeRequest.finally(() => {
                removeLoadingContainer($container);
                changeRequest = null;
            })
        })

        let pendingRequest;
        $lightboxTrigger.on('click', (e) => {
            const
                $target = $(e.currentTarget),
                url = $target.data('href');

            $lightbox.modal('show');

            pendingRequest = fetch(url)

            asyncAppend({
                $target: $lightboxContainer,
                $loading: $(getLoadingContainer()).appendTo($lightboxContainer)
            }, pendingRequest).then(() => {
                initLightbox($lightboxContainer)
            }).catch((error) => {
                console.error(error);
                $lightbox.modal('hide');
            })

            pendingRequest.finally(() => {
                removeLoadingContainer($lightboxContainer);
                pendingRequest = null;
            })
        })

        function handleProductInteraction(e) {
            e.preventDefault();

            const
                url = $(e.currentTarget).data('href')

            productRequest = fetch(url, {
                method: 'post'
            });

            asyncAppend({
                $target: $container,
                $loading: $(getLoadingContainer()).appendTo($container)
            }, productRequest).catch((error) => {
                console.error(error)
            })

            productRequest.finally(() => {
                removeLoadingContainer($container);
                productRequest = null;
            })
        }

        let productRequest;

        $products.each(function () {
            const $product = $(this);

            // show remove on touch
            $product.on("touchstart", function (e) {
                // not yet active, prevent default --> no click or hover etc.
                if (!$product.hasClass("active")) {
                    e.preventDefault();
                }

                $product.addClass("active");
            });

            $product.hover(function () {
                $product.addClass("active");
            }, function () {
                $product.removeClass("active");
            });

            // ie :( doesn't recognize click on remove
            $product.on("click", function(e) {
                if (!$product.hasClass("active")) {
                    return false;
                }

                handleProductInteraction(e)
            })

            $product.find(".js-strex-products__product-remove").on("click", (e) => {
                if (!$product.hasClass("active")) {
                    return false;
                }

                handleProductInteraction(e)
            });
        })

        $products.add($addProduct);
        $addProduct.on('click', handleProductInteraction);
    }

    function initLightbox($lightboxContainer) {
        const
            $grid = $lightboxContainer.find('.js-strex-product__grid'),
            $gridItems = $lightboxContainer.find('.js-strex-product__grid-item'),
            mobileBreakpoint = globalThis.matchMedia('(max-width: 767px)');

        let isOpen = false,
            pendingRequest,
            openRowIndex;

        $gridItems.on('click', (e) => {
            const
                $item = $(e.currentTarget),
                $html = $($lightbox.find('template').html()),
                $detailContainer = $html.find('.js-strex-product__item-detail-container'),
                index = $item.data("grid-index");

            if (pendingRequest) {
                return;
            }

            let targetRow

            if (mobileBreakpoint.matches) {
                targetRow = index + index % 2;
            } else {
                targetRow = Math.ceil(index / 6) * 6;
            }

            targetRow = targetRow > $gridItems.length ? $gridItems.length : targetRow;

            if (isOpen) {
                const $detailContainer = $lightbox.find('.js-strex-product__item-detail');
                $detailContainer.slideUp(250, function () {
                    $detailContainer.remove();
                    if (!$item.hasClass('active')) {
                        $gridItems.removeClass('active');
                        openDetail($item);
                    } else {
                        $item.removeClass('active');
                        isOpen = false;
                    }
                })
            } else {
                openDetail($item);
            }

            function openDetail($item) {
                const
                    url = $item.data('href');

                if (pendingRequest) {
                    pendingRequest.abort();
                }

                pendingRequest = fetch(url, {
                    method: 'GET'
                })

                asyncAppend({
                    $target: $html.find('.js-strex-product__item-detail-result'),
                    $loading: $(getLoadingContainer()).appendTo($item)
                }, pendingRequest).then(() => {
                    initDetail(url);
                    $html.slideDown(250, function () {
                        $item.addClass('active');
                        isOpen = true;
                    });
                });

                $grid.children().eq(targetRow - 1).after($html);

                pendingRequest.finally(() => {
                    removeLoadingContainer($item);
                    pendingRequest = null;
                })
            }

            function initDetail(url) {
                const
                    $form = $detailContainer.find('.js-strex-product__detail-form'),
                    $formInputs = $form.find('.js-form-auto-submit');

                let pendingRequest;

                $formInputs.on('change', function (e) {
                    const $this = $(this);

                    if ($this.data("field-target") && $this.data("value-target")) {
                        $form.find($this.data("field-target")).val($this.attr("name"));
                        $form.find($this.data("value-target")).val($this.val());
                    }

                    e.preventDefault();

                    if (pendingRequest) {
                        pendingRequest.abort();
                    }

                    let formData = new URLSearchParams(formDataEntries($form[0]))

                    pendingRequest = fetch(url, {
                        method: 'post',
                        body: formData
                    });

                    asyncAppend({
                        $target: $detailContainer.find('.js-strex-product__item-detail-result'),
                        $loading: $(getLoadingContainer()).appendTo($detailContainer)
                    }, pendingRequest).then(() => {
                        initDetail(url)
                    })

                    pendingRequest.finally(() => {
                        removeLoadingContainer($detailContainer);
                        pendingRequest = null;
                    })
                });

                $form.on('submit', (e) => {
                    e.preventDefault();

                    if (pendingRequest) {
                        pendingRequest.abort();
                    }

                    let formData = new URLSearchParams(formDataEntries($form[0]))

                    $lightbox.modal('hide');
                    $lightboxContainer = $lightbox.find('.js-strex-products__grid-container').empty();

                    pendingRequest = fetch($form.data('action'), {
                        method: 'post',
                        body: formData
                    });

                    asyncAppend({
                        $target: $container,
                        $loading: $(getLoadingContainer()).appendTo($container)
                    }, pendingRequest).catch((error) => {
                        console.error(error)
                    })

                    pendingRequest.finally(() => {
                        removeLoadingContainer($container);
                        pendingRequest = null;
                    })
                });
            }

            /**
             * manuel polyfill. addListener is deprecated but in ie and edge addEventListerner is not yet supported
             */
            if (document.documentMode || /Edge/.test(navigator.userAgent) || (/iPad|iPhone|iPod/.test(navigator.userAgent) || navigator.userAgent.indexOf("Safari") !== -1 && !globalThis.MSStream)) {
                mobileBreakpoint.addListener((e) => {
                    if (e.matches) {
                        //mobile gets fired

                    } else {

                    }
                })
            } else {
                mobileBreakpoint.addEventListener('change', (e) => {
                    if (e.matches) {
                        //mobile gets fired

                    } else {

                    }
                })
            }
        })

        if (document.documentMode || /Edge/.test(navigator.userAgent) || (/iPad|iPhone|iPod/.test(navigator.userAgent) || navigator.userAgent.indexOf("Safari") !== -1 && !globalThis.MSStream)) {
            mobileBreakpoint.addListener((e) => {
                $lightbox.find('.js-strex-product__grid-preview').remove();
            })
        } else {
            mobileBreakpoint.addEventListener('change', (e) => {
                $lightbox.find('.js-strex-product__grid-preview').remove();
            })
        }
    }
}